export default "__VITE_ASSET__BTK2AAQm__"